import { render, staticRenderFns } from "./EditPersonToggle.vue?vue&type=template&id=01bfbbe4&scoped=true&"
import script from "./EditPersonToggle.vue?vue&type=script&lang=js&"
export * from "./EditPersonToggle.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonToggle.vue?vue&type=style&index=0&id=01bfbbe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bfbbe4",
  null
  
)

export default component.exports